import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=47ed8e96&scoped=true&"
import script from "./Index.vue?vue&type=script&setup=true&lang=js&"
export * from "./Index.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=47ed8e96&prod&lang=scss&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=47ed8e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed8e96",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSeparator,QImg,QBtn});
